module.exports = __webpack_public_path__ + "img/Attributsbonustabelle.bbd4636c.jpeg";